import { DataBean } from "../DataBean";

export class QualityInspectionLote extends DataBean {

  public async getQualityInspectionLoteCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionLoteCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionLoteRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionLoteRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async getProductionOrderByYearAndProductionOrder(  idProductionOrder: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getProductionOrderByYearAndProductionOrder_Number",
      [ idProductionOrder]
    );
  }

  public async deleteQualityInspectionLote(idqualityinspectionlote: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionLote_Number", [idqualityinspectionlote]);
  }

  public async updateQualityInspectionLote(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionLote_updateQualityInspectionLote_com.orange.finance.processcontract.bean.QualityInspectionLote",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionLote",
        },
      ]
    );
  }
}
